// extracted by mini-css-extract-plugin
export default {"footer":"EmailDrawerFooter_footer__tAiCl"};